<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Adresse</mat-label>
                    <input matInput data-input-email type="text" formControlName="address" autocomplete="off" required />
                    @if (formGroupErrors?.address?.required && (formGroup.controls['address']?.dirty || formGroup.controls['address'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Addresse' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO addresse" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="isActive">Active</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    matTooltip="Une adresse inactive ne peut être utilisée pour recevoir ou emettre des mails."
                    matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="sendingEnabled">Envoi autorisé</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    matTooltip="Par défaut une adresse permet uniquement la réception de mail; cette option permet d'utiliser l'adresse pour emettre des mails."
                    matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom affiché</mat-label>
                    <input matInput type="text" formControlName="emailDisplayName" autocomplete="off" />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO emailDisplayName" matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
